import * as React from "react";
const SvgDrinkNonAlcoholic = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.749.293a.75.75 0 0 1 .459.956L15.802 5.25H18a.75.75 0 0 1 .745.838l-2 17a.75.75 0 0 1-.745.662H8a.75.75 0 0 1-.745-.662l-2-17A.75.75 0 0 1 6 5.25h8.212l1.58-4.498a.75.75 0 0 1 .957-.46Zm-4.294 9.957 1.23-3.5H6.843l.412 3.5h5.2Zm1.063 1.5H15a.75.75 0 0 0 0-1.5h-.955l1.23-3.5h1.882l-1.824 15.5H8.667l-1.235-10.5h4.496l-2.636 7.502a.75.75 0 1 0 1.416.497l2.81-7.999Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgDrinkNonAlcoholic;
